import { Typography } from '@mui/material';
import React, { Fragment } from 'react';

import { FormikTextField } from 'components';
import { formatUtils } from 'utils';

type Props = {
  label: string;
  name?: string;
  commentedAt?: string | Date | null;
  commentedBy?: { name?: string } | null;
};

export const CommentField: React.FC<Props> = ({
  label,
  name = 'comment',
  commentedAt,
  commentedBy,
}) => (
  <Fragment>
    <FormikTextField
      label={label}
      name={name}
      multiline
      rows={3}
      inputProps={{ maxLength: 1000 }}
    />
    {commentedAt && (
      <Typography variant="caption" color="text.secondary" className="!tw-mt-2">
        {formatUtils.formatDate(commentedAt)}
        {': '}
        {commentedBy?.name}
      </Typography>
    )}
  </Fragment>
);
